module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "id": "loading-screen"
    }
  }, [_c('div', {
    staticClass: "fancy-loader"
  }, [_c('span', [_vm._v("LOADING")]), _vm._v(" "), _c('svg', {
    staticClass: "lds-comets",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "250px",
      "height": "250px",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid"
    }
  }, [_c('g', {
    attrs: {
      "transform": "rotate(162.228 50 50)"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "repeatCount": "indefinite",
      "values": "360 50 50;240 50 50;120 50 50;0 50 50",
      "keyTimes": "0;0.333;0.667;1",
      "dur": "1s",
      "keySplines": "0.7 0 0.3 1;0.7 0 0.3 1;0.7 0 0.3 1",
      "calcMode": "spline"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#41918E",
      "d": "M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E0E0E0",
      "d": "M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#80CBC4",
      "d": "M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-md-12"
  }, [_c('div', {
    attrs: {
      "data-intro": "<b>Not Available on Help page</b><p>To play the tour guide, click on MSDAT platform and select the tour guide</p>"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: ('Back to platform'),
      expression: "'Back to platform'",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "back-to-car-icon",
    on: {
      "click": _vm.navigateToCentralAnalytics
    }
  }, [_c('v-icon', {
    staticClass: "back-to-car-icon-v",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("arrow_back")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "nanleContainer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "cnick col-md-6"
  }, [_c('aside', [_c('h1', [_vm._v("About Platform")]), _vm._v(" "), _c('p', {
    staticClass: "about_content"
  }, [_vm._v("\n              The essence of health data is to ensure that decision-makers have the means to make informed decisions and policies for healthcare.\n              "), _c('a', {
    staticClass: "visible-xs-block",
    on: {
      "click": function($event) {
        _vm.aboutContent = !_vm.aboutContent
      }
    }
  }, [_vm._v(_vm._s(_vm.aboutContent ? 'Show Less' : 'Show More'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aboutContent),
      expression: "aboutContent"
    }]
  }, [_c('p', {
    staticClass: "about_content"
  }, [_vm._v("This Multi-Source Data Analytic and Triangulation resource developed by the Federal Ministry of Health (FMoH) Nigeria provides a single transparent view of key health indicators from multiple data sources. Recognizing that data quality, trends and interpretation depend on the data source and methodology, the platform offers comparisons of key metrics across three categories of data sources, namely; routine, surveys, and global estimates. ")]), _vm._v(" "), _c('p', {
    staticClass: "about_content"
  }, [_vm._v("By transparently visualizing data and trends across multiple sources, we intend improving the debate and focus on data quality and its use, so as to reduce variations that exist between different sources over time and improve our overall understanding of key trends and progress within the health sector.")]), _vm._v(" "), _c('p', {
    staticClass: "about_content"
  }, [_vm._v("\n              This resource has been developed and is being expanded in phases building on connections with existing FMOH agencies and partners. As this resource evolves, DHPRS hopes to contribute to improved performance management within the health sector. \n            ")]), _vm._v(" "), _c('p', {
    staticClass: "about_content"
  }, [_vm._v("\n              The first phase started with exploration analysis using some selected indicators at the federal and state level. Subsequent phases will gradually increase the number of indicators available for analysis, and then widen the coverage of health data analysis to LGA and facility level as well.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "about_content"
  }, [_vm._v("\n              The DHPRS team welcomes feedback on this resource and invites stakeholders to upload relevant data using the submit data button on the platform.\n            ")])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "15px"
    }
  }, _vm._l((_vm.indicators), function(indicator, index, i) {
    return _c('div', {
      key: i,
      staticClass: "col-xs-12 col-md-3",
      staticStyle: {
        "padding-bottom": "32px",
        "padding-top": "10px"
      }
    }, [_c('div', {
      staticClass: "indicator-names-button",
      on: {
        "click": function($event) {
          indicator.show = !indicator.show
        }
      }
    }, [_c('span', [_vm._v("\n          " + _vm._s(index) + "\n          "), _c('v-icon', {
      staticStyle: {
        "color": "white",
        "float": "right"
      }
    }, [_vm._v(_vm._s(indicator.show ? 'fa fa-caret-up' : 'fa fa-caret-down'))])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (indicator.show),
        expression: "indicator.show"
      }],
      staticClass: "indicator-text"
    }, _vm._l((indicator.children), function(name, count) {
      return _c('span', {
        key: count
      }, [_vm._v("\n          " + _vm._s(name) + "\n        ")])
    }))])
  })), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAvailableSourceTable),
      expression: "showAvailableSourceTable"
    }],
    staticClass: "row",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-div"
  }, [_c('table', {
    staticClass: "Table",
    class: {
      'TableDefault': true, 'TableNormal': _vm.wrapperClick
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.dataSourceForTable), function(col, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(col))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.availableSourceData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(data.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.indicator))]), _vm._v(" "), _vm._l((_vm.isDataForSourceAvailable[data.indicator]), function(icon, i) {
      return _c('td', {
        key: i
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (icon),
          expression: "icon"
        }, {
          name: "tooltip",
          rawName: "v-tooltip.top",
          value: ('Click to see available years'),
          expression: "'Click to see available years'",
          modifiers: {
            "top": true
          }
        }],
        staticStyle: {
          "cursor": "default",
          "height": "20px",
          "margin": "30px auto",
          "width": "50%",
          "padding-right": "60px"
        },
        on: {
          "click": function($event) {
            _vm.showModal([data.indicator, i])
          }
        }
      }, [_c('v-icon', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (icon),
          expression: "icon"
        }],
        attrs: {
          "dark": "",
          "color": "green"
        }
      }, [_vm._v("check_circle")])], 1)])
    })], 2)
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 col-md-offset-5 col-xs-offset-4",
    staticStyle: {
      "padding-top": "20px",
      "padding-bottom": "80px",
      "color": "white"
    }
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#007D53",
      "color": "white",
      "box-shadow": "0px 2px 15px rgba(0, 0, 0, 0.4)",
      "border-color": "#007D53"
    },
    on: {
      "click": _vm.wrapperClicked
    }
  }, [_vm._v(_vm._s(_vm.wrapperClick ? 'Show More' : 'Show Less'))])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {}, _vm._l((_vm.filterSourceRoutine(_vm.metaData)), function(data, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-12 col-md-4",
      staticStyle: {
        "padding-bottom": "32px"
      }
    }, [_c('div', {
      staticClass: "indicator-names-button",
      on: {
        "click": function($event) {
          data.show = !data.show
        }
      }
    }, [_c('span', [_vm._v("\n            " + _vm._s(data.source) + "\n            "), _c('v-icon', {
      staticStyle: {
        "color": "white",
        "float": "right"
      }
    }, [_vm._v(_vm._s(data.show ? 'fa fa-caret-up' : 'fa fa-caret-down'))])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.show),
        expression: "data.show"
      }],
      staticClass: "indicator-text"
    }, [_c('span', [_c('p', [_vm._v(_vm._s(data.description) + " "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.viewSourceMetadata(data.source)
        }
      }
    }, [_vm._v("Show more")])])])])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {}, _vm._l((_vm.filterSourceSurvey(_vm.metaData)), function(data, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-12 col-md-4",
      staticStyle: {
        "padding-bottom": "32px"
      }
    }, [_c('div', {
      staticClass: "indicator-names-button",
      on: {
        "click": function($event) {
          data.show = !data.show
        }
      }
    }, [_c('span', [_vm._v("\n            " + _vm._s(data.source) + "\n            "), _c('v-icon', {
      staticStyle: {
        "color": "white",
        "float": "right"
      }
    }, [_vm._v(_vm._s(data.show ? 'fa fa-caret-up' : 'fa fa-caret-down'))])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.show),
        expression: "data.show"
      }],
      staticClass: "indicator-text"
    }, [_c('span', [_c('p', [_vm._v(_vm._s(data.description) + " "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.viewSourceMetadata(data.source)
        }
      }
    }, [_vm._v("Show more ")])])])])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.filterSourceEstimate(_vm.metaData)), function(data, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-12 col-md-4",
      staticStyle: {
        "padding-bottom": "32px"
      }
    }, [_c('div', {
      staticClass: "indicator-names-button",
      on: {
        "click": function($event) {
          data.show = !data.show
        }
      }
    }, [_c('span', [_vm._v("\n            " + _vm._s(data.source) + "\n            "), _c('v-icon', {
      staticStyle: {
        "color": "white",
        "float": "right"
      }
    }, [_vm._v(_vm._s(data.show ? 'fa fa-caret-up' : 'fa fa-caret-down'))])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.show),
        expression: "data.show"
      }],
      staticClass: "indicator-text"
    }, [_c('span', [_c('p', [_vm._v(_vm._s(data.description) + " "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.viewSourceMetadata(data.source)
        }
      }
    }, [_vm._v("Show more")])])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4 col-md-offset-9 col-xs-offset-3"
  }, [_c('div', {
    attrs: {
      "id": "bottom_of_page"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/central_analytics"
    }
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#007D53",
      "color": "white",
      "box-shadow": "0px 2px 15px rgba(0, 0, 0, 0.4)",
      "border-color": "#007D53"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" Back to platform ")])])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.showModalBoolean,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.showModalBoolean = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card modal-card1"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-title-text"
  }, [_vm._v("The "), _c('b', [_vm._v(_vm._s(_vm.indicator))]), _vm._v(" indicator is available on "), _c('b', [_vm._v(_vm._s(_vm.source))]), _vm._v(" for these years:")]), _vm._v(" "), _c('span', {
    staticClass: "close-year-modal is-danger pull-right",
    on: {
      "click": function($event) {
        _vm.showModalBoolean = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body year-body"
  }, [_c('div', _vm._l((_vm.yearsForSource), function(year, count) {
    return _c('p', {
      key: count
    }, [_vm._v("\n                    " + _vm._s(year) + ",\n                  ")])
  }))])])])]), _vm._v(" "), (_vm.isSourceMetaModalActive) ? _c('div', [_c('table-modal', {
    attrs: {
      "src": _vm.datasingle,
      "sourceMetaData": _vm.datafull
    },
    on: {
      "switchOff": _vm.clearModal
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('h1', {
    staticClass: "about_title",
    attrs: {
      "id": "top_of_page"
    }
  }, [_vm._v("Multi-Source Data Analytics and Triangulation Platform")]), _vm._v(" "), _c('h5', {
    staticClass: "about_subtitle"
  }, [_vm._v("This platform is developed and managed by the Department of Health, Planning and Research Statistics (DHPRS)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "static/img/About-Dashboard-image.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 cnick"
  }, [_c('h1', [_vm._v("Indicators")]), _vm._v(" "), _c('p', {
    staticClass: "about_content"
  }, [_vm._v("The indicators available on the Multi-Source Data Analytics and Triangulation Platform have been categorized by their program areas and can be seen below. To see the indicators, click the drop down on each program area.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 cnick"
  }, [_c('h1', [_vm._v("Available Data")]), _vm._v(" "), _c('span', {
    staticClass: "about_content"
  }, [_vm._v("\n        Below is the total available data on this platform, all the indicators and their data sources with the available years\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 cnick"
  }, [_c('div', {}, [_c('h1', [_vm._v("Data sources")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8rem"
    }
  }, [_vm._v("\n          The list of Data sources available on the Platform can be found below:\n          ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4 cnick"
  }, [_c('h1', [_vm._v("Routine")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4 cnick"
  }, [_c('h1', [_vm._v("Survey")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4 cnick"
  }, [_c('h1', [_vm._v("Estimate")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4eb42427","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboards/car/mainCar/about.vue
// module id = 965
// module chunks = 1